import { useContext, useState } from "react";
import { hasUnsyncedChanges } from "@nozbe/watermelondb/sync";
import { database } from "../../database";
import { handleBusinessReportUrl, Sync } from "../../SyncService";
import { useSnackbar } from "../../context/SnackbarContext";
import { LanguageContext } from "../../context/LanguageContext";
import { isDemoMode } from "../../utils/demoEnviornment";
import { REPORT_URL } from "../../constants";
import { useAuthContext } from "../../context/AuthContext";
import { handleApi } from "../../apis";
import { PDF_DOWNLOAD } from "../../apis/configuration";
import { useNavigate } from "react-router-dom";
import fileDownload from "js-file-download";

const useDownlaodPdf = (user, endPoint) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState({ downloadLoading: false });
  const { showSnackbar } = useSnackbar();
  const [I18n] = useContext(LanguageContext);
  const { business } = useAuthContext();
  const handleDownloadPDF = async (params, onSuccess = () => {}, pdfType) => {
    try {
      if (!user._raw?.phone_number || isDemoMode()) {
        showSnackbar({
          message: I18n.report_download_is_not_available_yet,
          severity: "error",
        });
        setLoading({ downloadLoading: false });
        return;
      }

      setLoading({ downloadLoading: true });

      //  Handle Repor Url generation here
      let rep_url;
      if (user?._raw?.phone_number) {
        if (business?.report_url) {
          rep_url = business.report_url;
        } else {
          rep_url = await handleBusinessReportUrl(business, navigate);
        }

        params["payment_link"] =
          `${REPORT_URL}/i/${rep_url}/${params?.invoice_id?.split("-")[0]}`;
      }

      const response = await handleApi(
        endPoint ? endPoint : PDF_DOWNLOAD,
        params,
        null,
        navigate,
        null,
        { responseType: "blob" },
      );

      if (!params?.html) {
        fileDownload(response, params.name);
      }
      if (typeof onSuccess == "function") onSuccess(response);

      if (!params?.html) {
        showSnackbar({
          message:
            pdfType === "Invoice"
              ? I18n.successfully_download_invoice
              : I18n.report_download,
          severity: "success",
        });        
      }
    } catch (err) {
      showSnackbar({
        message: I18n.error_downloading_report,
        severity: "error",
      });
    } finally {
      setLoading({ downloadLoading: false });
    }
  };

  const onDownload = async (
    params = {},
    onSuccess = () => {},
    navigate,
    pdfType,
  ) => {
    try {
      let syncStatus = await hasUnsyncedChanges({ database });
      setLoading({ downloadLoading: true });
      if (syncStatus) {
        Sync(user.phone_number, navigate)
          .then((res) => {
            if (res === "in_progress") {
              showSnackbar({
                message: I18n.backup_in_progress_shortly,
                severity: "error",
              });
              setLoading({ downloadLoading: false });
            } else handleDownloadPDF(params, onSuccess, pdfType);
          })
          .catch((err) => {
            showSnackbar({
              message: I18n.error_downloading_report,
              severity: "error",
            });
            setLoading({ downloadLoading: false });
          });
      } else handleDownloadPDF(params, onSuccess, pdfType);
    } catch (err) {
      setLoading({ downloadLoading: false });
    }
  };

  const { downloadLoading } = loading || {};

  return {
    downloadLoading,
    onDownload,
  };
};

export default useDownlaodPdf;
